import type React from "react";
import { createContext } from "react";
import { calculateFormInitialState } from "../reducers/InitialStates/CalculatorInitialState";
import type { Action, ICalculatorFormState } from "../types/types";

export const AppContext = createContext<{
  state: ICalculatorFormState;
  dispatch: React.Dispatch<Action>;
}>({
  state: calculateFormInitialState,
  dispatch: () => null,
});
